
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <div className="text-center max-w-md mx-auto">
        {/* 404 Illustration */}
        <div className="mb-8">
          <img 
            src="/images/404.svg" 
            alt="404 - Page Not Found" 
            className="w-64 h-64 mx-auto opacity-80"
          />
        </div>

        {/* Content */}
        <div className="space-y-4">
          <h1 className="text-4xl font-bold text-foreground">Page Not Found</h1>
          <p className="text-lg text-muted-foreground">
            Oops! The page you're looking for seems to have wandered off into the digital void.
          </p>
          <p className="text-sm text-muted-foreground">
            Don't worry though, let's get you back on track.
          </p>
          
          <div className="pt-4">
            <Button 
              onClick={() => window.location.href = "/"} 
              className="px-6 py-2"
            >
              Return Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
